import React, { useState, useEffect, ChangeEvent, useCallback, FormEvent } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SiteWrapper from "../../base/SiteWrapper";

import Level from '../../interfaces/Level';

import {
  Page,
  Button,
  Form,
  Card,
  Icon
} from "tabler-react";
import { ApiFidegg } from "../../services/apiFideggAdmin";
import { Alerta } from "../../utils/Alerta";
import Params from "../../interfaces/Params";

function LevelsForm() {

  const history = useHistory();

  const { id } = useParams<Params>();

  const initialValues: Level = {
    id: "",
    name: "",
    points_needed: "",
    multiplier: ""
  };

  const [level, setLevel] = useState<Level>(initialValues);

  useEffect(() => {
    (async () => {
      if(!!id) {
        try {
          const response = await ApiFidegg.get(`levels/${id}`);
          if (response.status === 200) {
            setLevel(response.data);
          }
        } catch (e) {
          console.error(e);
        }
      }
    })();
  }, [id]);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setLevel({...level, [name]: value});
  }

  function handleClickCancel(event: FormEvent) {
    event.preventDefault();
    history.goBack();
  }

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      try {
        event.preventDefault();

        const data = {
          "name": level.name,
          "points_needed": level.points_needed,
          "multiplier": level.multiplier
        }

        if(!!level.id) {
          await ApiFidegg.put(`levels/${level.id}`, data)
          Alerta('Nível atualizado!', 'success');
        } else {
          await ApiFidegg.post('levels', data)
          Alerta('Nível incluído!', 'success');
        }

        history.push('/levels');
      } catch (err) {
        if(!!level.id) {
          Alerta('Erro ao atualizar o nível!');
        } else {
          Alerta('Erro ao cadastrar o nível!');
        }
      }
    }, [history, level]
  );

  return (
    <SiteWrapper>
      <Form onSubmit={handleSubmit}>
        <Page.Card
          title="Nível"
          footer={
            <Card.Footer>
              <div className="d-flex">
                <Button link onClick={handleClickCancel} >Cancelar</Button>
                <Button type="submit" color="primary" className="ml-auto">
                  Salvar
                </Button>
              </div>
            </Card.Footer>
          }
        >
          <Form.FieldSet>
            <Form.Group label="Nome">
              <Form.Input
                name="name"
                value={level.name || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group label="Pontos Necessários">
              <Form.Input
                name="points_needed"
                value={level.points_needed || ""}
                onChange={handleChange}
                type="number"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Multiplicador
                <Icon name="help-circle" style={{marginLeft:'5px'}} title="Percentual para que, quando informado, os usuário deste nível tenham mais vantagem na obtenção de pontos" />
              </Form.Label>
              <Form.Input
                name="multiplier"
                value={level.multiplier || ""}
                onChange={handleChange}
                type="number"
              />
            </Form.Group>
          </Form.FieldSet>
        </Page.Card>
      </Form>
    </SiteWrapper>
  );
}

export default LevelsForm;